export const mediaQueryMobile = "(max-width: 455px)";
